const TOKEN_KEY = 'token';

/**
 * The previous build also cached the whole user record here and read its `id`
 * back to fetch the profile. The API no longer accepts a user id for that —
 * it reads the caller from the token — so the key is obsolete, and it is
 * cleared rather than merely ignored so a browser left over from the old
 * build does not keep a stale record around.
 */
const LEGACY_USER_KEY = 'user';

export const getToken = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token || !token.trim()) return null;
  return token;
};

export const saveSession = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LEGACY_USER_KEY);
};

/**
 * Absent rather than empty when there is no token: an empty `authorization`
 * header is a header the server still has to reason about.
 */
export const authHeader = () => {
  const token = getToken();
  return token ? { authorization: `Bearer ${token}` } : {};
};
